// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__uiIB-","productName":"Table_productName__2swNw"};